export default __webpack_public_path__ + "static/media/banner-biblioteca.109b61ed.jpg";